import styled from 'styled-components';
// import {media} from '../../utils/styleUtils'

const SubTitle = styled.div`
  font-size: 1.5rem;
  font-weight: 300;
  text-align: justify;
`;

export default SubTitle;
